import { render, staticRenderFns } from "./ExcavationPermit.vue?vue&type=template&id=143ec6ad"
import script from "./ExcavationPermit.vue?vue&type=script&lang=js"
export * from "./ExcavationPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports